import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface PrizeDistributionItem {
  position?: string;
  range?: string;
  amount: number;
}

export interface PrizePoolData {
  totalAmount: number;
  paymentMethod: string;
  distribution: PrizeDistributionItem[] | null;
}

@Component({
  selector: 'app-prize-pool',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './prize-pool.component.html',
  styleUrl: './prize-pool.component.scss'
})
export class PrizePoolComponent {
  @Input() prizePool!: PrizePoolData;
}


